// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190435/js/" + chunkId + "." + {"44":"8a5647d0","225":"97524eff","481":"61ea68a2","486":"b089fdbe","770":"2da2fb73"}[chunkId] + ".0.12398849420061264.chunk.js";
};